export const FIELDS = {

  ID: 'id',
  WORKFLOW_ITEM_ID: 'workflowItemId',
  SODATE: 'soDate',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  PROFORMA_INVOICE_ID: 'proformaInvoiceId',
  BILLING_ADDRESS_ID: 'billingAddressId',
  SHIPPING_ADDRESS_ID: 'shippingAddressId',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  BILLING_TERM_ID: 'billingTermId',
  COMMENTS: 'comments',
  INTERNAL_COMMENTS: 'internalComments',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  TAX_NUMBER: 'taxNumber',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  SHIPPING_CHARGES: 'shippingCharges',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TAX: 'tax',
  TOTAL: 'total',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  ESTIMATED_PROFIT: 'estimatedProfit',
  ESTIMATED_MARGIN: 'estimatedMargin',
  ACTUAL_PROFIT: 'actualProfit',
  ACTUAL_MARGIN: 'actualMargin',
  ATTENTION: 'attention',
  CUSTOMER_PO: 'customerPo',
  SHIP_ON_COMPANY_ACCOUNT: 'shipOnCompanyAccount',
  ALWAYS_SHIP_BY: 'alwaysShipBy',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  STATUS_ID: 'statusId',
  SALES_TYPE_ID: 'salesTypeId',
  INCO_TYPE_ID: 'incoTypeId',
  RISK_ASSESSMENT_TYPE_ID: 'riskAssessmentTypeId',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  DATE_EMAILED: 'dateEmailed',
  ON_HOLD: 'onHold',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SONO: 'soNo',
  COMPANY_NAME: 'companyName',
  CONTACT_FIRST_NAME: 'contactFirstName',
  CONTACT_LAST_NAME: 'contactLastName',
  CONTACT_FULL_NAME: 'contactFullName',
  CONTACT_EMAIL: 'contactEmail',
  AMOUNT_PAID: 'amountPaid',
  CREDIT_AMOUNT: 'creditAmount',
  BALANCE: 'balance',
  BILLING_ADDRESS: 'billingAddress',
  SHIPPING_ADDRESS: 'shippingAddress',
  STATUS_NAME: 'statusName',
  BILLING_TERM_NAME: 'billingTermName',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  WORKFLOW_ITEM_NAME: 'workflowItemName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  SALES_TYPE_NAME: 'salesTypeName',
  SORT_ORDER: 'sortOrder',
  LINE_COUNT: 'lineCount',
  TOTAL_QUANTITY: 'totalQuantity',
  TOTAL_COST: 'totalCost',
  TOTAL_PRICE: 'totalPrice',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  EXPR1: 'expr1',
  INCO_TYPE_NAME: 'incoTypeName',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  SHIPPING_NOTES: 'shippingNotes',
  NAME: 'name',
};